@if (hasHighlights()) {
  <mat-icon class="icon" svgIcon="comp-name-match" [matTooltip]="'sharedInputs.hasHighlights.matchedCompanyName' | transloco"></mat-icon>
} @else if (hasHighlights() !== undefined) {
  <mat-icon class="icon" svgIcon="comp-tree-match" [matTooltip]="'sharedInputs.hasHighlights.matchedHierarchy' | transloco"></mat-icon>
}
